'use strict';

var FlightLevelChartAggregationFactory = function FlightLevelChartAggregationFactory(FlightThematicDataAggregationFactory, ExtractMetricKeysService) {
  function FlightLevelChartAggregation() {
    FlightThematicDataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'flight-level-chart');
  }
  FlightLevelChartAggregation.prototype = Object.create(FlightThematicDataAggregationFactory.prototype);
  FlightLevelChartAggregation.constructor = FlightLevelChartAggregation;
  FlightLevelChartAggregation.prototype.aggregate = function (data, metrics, metricDescriptor) {
    var aggregationFunction = this.getAggregationFunction(metrics, metricDescriptor);
    var groupedData = {},
      keys,
      keysLength,
      metricKeys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(groupedData[data[index].numberAndDate])) {
        groupedData[data[index].numberAndDate].push(data[index]);
      } else {
        groupedData[data[index].numberAndDate] = [data[index]];
      }
    }
    keys = Object.keys(groupedData);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      var reducedEntry = {};
      var time = keys[index];
      var element = groupedData[time][0];
      reducedEntry.departureDate = element.flightDepartureDate;
      reducedEntry.departureDateMoment = element.flightDepartureDateMoment;
      reducedEntry.departureTimeMoment = element.flightDepartureTimeMoment;
      reducedEntry.numberAndDate = element.numberAndDate;
      reducedEntry.opsSuffix = element.opsSuffix;
      reducedEntry.flightNumber = element.flightNumber;
      reducedEntry.flightId = element.flightId;
      reducedEntry.carrier = element.carrier;
      reducedEntry.isLastYearData = element.flightId === undefined;
      reducedEntry.leg = element.leg;
      reducedEntry.legDepartureDateMoment = element.legDepartureDateMoment;
      reducedEntry.label = time;
      metricKeys = ExtractMetricKeysService.extract(element);
      aggregationFunction(groupedData[time], metricKeys, reducedEntry);
      groupedData[time] = reducedEntry;
    }
    return this.sortAggregationResults(groupedData);
  };
  return FlightLevelChartAggregation;
};
FlightLevelChartAggregationFactory.$inject = ['FlightThematicDataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = FlightLevelChartAggregationFactory;